import { render, staticRenderFns } from "./pop-up-container.vue?vue&type=template&id=6f4a5df4&scoped=true"
import script from "./pop-up-container.vue?vue&type=script&lang=js"
export * from "./pop-up-container.vue?vue&type=script&lang=js"
import style0 from "./pop-up-container.vue?vue&type=style&index=0&id=6f4a5df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4a5df4",
  null
  
)

export default component.exports